import css from '@styled-system/css'
import React, { ReactNode, useState } from 'react'
import Box from '../primitives/Box'

export function Transcript({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false)
  return (
    <Box paddingBottom={open ? 40 : 24} position="relative">
      <Box.h2
        font="h4"
        paddingTop={24}
        marginTop={24}
        marginBottom={24}
        fontWeight={700}
        id="transcript"
      >
        Transcript
      </Box.h2>
      <Box
        position="relative"
        maxHeight={!open ? 484 : undefined}
        marginBottom={48}
        overflow="hidden"
      >
        {children}
        {!open ? (
          <Box
            position="absolute"
            height={70}
            width="100%"
            css={`
              background: linear-gradient(
                180deg,
                rgba(255, 255, 255, 0) 0%,
                #ffffff 100%
              );
            `}
            left={0}
            bottom={0}
            zIndex={1}
          />
        ) : null}
      </Box>
      <Box.button
        onClick={() => setOpen(!open)}
        bottom={0}
        left={0}
        position="absolute"
        font="medium"
        fontWeight={700}
        height={32}
        color="podcastBlue"
        css={css({
          ':hover': {
            color: 'black',
          },
        })}
        zIndex={2}
      >
        Show {open ? 'less' : 'more'}
      </Box.button>
    </Box>
  )
}
